import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    paddingLeft: pxToRem(16),
    paddingTop: pxToRem(12),
    paddingBottom: pxToRem(12),
    backgroundColor: theme.palette.neutralWhite,
    wordBreak: 'break-all',
    selectors: {
      [layout.breakpoints.min.md]: {
        paddingLeft: pxToRem(24),
      },
    },
  },
  leftBorder: {
    paddingLeft: pxToRem(12),
    selectors: {
      [layout.breakpoints.min.md]: {
        paddingLeft: pxToRem(18),
      },
    },
  },
  large: {
    paddingTop: '1rem',
    paddingBottom: '1rem',
    backgroundColor: theme.palette.neutralWhite,
  },
  // this is just so the border can sit around the card
  borderWrapper: {
    borderBottom: `1px solid ${theme.palette.neutralQuaternary}`,
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 600,
    alignItems: 'center',
    paddingBottom: pxToRem(3),
  },
});
